import { FC } from 'react';
import { Control } from 'react-hook-form';
import styled from 'styled-components';

import { Label } from '@/components/Forms';
import { NewDropdown } from '@/components/Forms/Dropdown';
import FormField from '@/components/Forms/FormField';

import { FormDataT } from './FreelancerWagesModal';

const currencies = [
  {
    label: '€',
    value: 'euro',
  },
  {
    label: '$',
    value: 'dollar',
  },
  {
    label: '£',
    value: 'pound',
  },
];

const InputHolder = styled.div`
  display: flex;
`;

const DropdownHolder = styled.div`
  width: 82px;
  flex-shrink: 0;
  margin-right: 16px;
`;

const FormFieldHolder = styled.div`
  flex: 1;
  position: relative;
`;

const WageHolder = styled.div`
  margin-top: 24px;
`;

const StyledFormField = styled(FormField)`
  input {
    padding-right: 60px;
  }
`;

interface Props {
  control: Control<FormDataT>;
  currencyName:
    | 'hour_currency'
    | 'day_currency'
    | 'month_currency'
    | 'job_currency';
  amountName: 'hour_amount' | 'day_amount' | 'month_amount' | 'job_amount';
  dateName:
    | 'hour_wage_changed_at'
    | 'day_wage_changed_at'
    | 'month_wage_changed_at'
    | 'job_wage_changed_at';
  type: string;
}

const FreelancerWageField: FC<Props> = ({
  control,
  currencyName,
  amountName,
  dateName,
  type,
}) => {
  return (
    <>
      <FormField
        control={control}
        name={dateName}
        label="Wage Start / Change"
        type="datepicker"
        datepickerType="date"
      />
      <WageHolder>
        <Label>{type} Wage</Label>
        <InputHolder>
          <DropdownHolder>
            <NewDropdown
              options={currencies}
              control={control}
              name={currencyName}
            />
          </DropdownHolder>
          <FormFieldHolder>
            <StyledFormField
              type="text"
              control={control}
              name={amountName}
              placeholder="Add amount"
            />
          </FormFieldHolder>
        </InputHolder>
      </WageHolder>
    </>
  );
};

export default FreelancerWageField;
